/**
 * Indicateur de chargement (session / finalisation sign-in).
 *
 * On NE rend PLUS de splash plein-écran : sur iOS, le `LaunchScreen.storyboard`
 * natif affiche déjà la flamme Flambeau au démarrage à froid. Un 2e splash React
 * (flamme identique) créait un « flash entre deux écrans » au démarrage. On garde
 * donc un indicateur minimal et discret (web ET natif), `role="status"` pour
 * l'accessibilité.
 */
export function SplashScreen() {
  return (
    <div
      className="flex min-h-[40vh] items-center justify-center"
      role="status"
      aria-label="Chargement d'Écoute"
    >
      <span className="text-small text-muted">Chargement…</span>
    </div>
  );
}
